import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

function GmailAuthCallback() {
  const [authStatus, setAuthStatus] = useState('processing');

  useEffect(() => {
    // You can add an API call here to verify the auth status if needed
    // For now, we'll assume it's always successful
    setAuthStatus('success');
  }, []);

  return (
    <div className="gmail-auth-callback">
      <h2>Gmail Authorization</h2>
      {authStatus === 'processing' && <p>Processing your authorization...</p>}
      {authStatus === 'success' && (
        <>
          <p>Gmail account successfully authorized!</p>
          <Link to="/dashboard">Go to Dashboard</Link>
        </>
      )}
      {authStatus === 'error' && (
        <p>There was an error authorizing your Gmail account. Please try again.</p>
      )}
    </div>
  );
}

export default GmailAuthCallback;
